import { render, staticRenderFns } from "./PackageTrendChart.vue?vue&type=template&id=37d93b9e"
import script from "./PackageTrendChart.vue?vue&type=script&lang=js"
export * from "./PackageTrendChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports